import app from 'flarum/forum/app';

/**
 * Som de notificação. Não toca se o canal da mensagem está na tela e em foco, e é
 * limitado por tempo para uma rajada de mensagens soar uma vez só. O admin escolhe
 * o arquivo; a preferência do usuário de silenciar vence.
 */

/** Intervalo mínimo entre dois toques. */
const THROTTLE_MS = 2000;
let lastPlayed = 0;
let element = null;
let loadedFor = null;

/** Arquivo escolhido pelo admin, ou null com som desligado no fórum ou pelo usuário. */
function chosen() {
  var _app$session$user;
  // Ausente significa "seguir o fórum"; só um `false` explícito silencia.
  if (((_app$session$user = app.session.user) == null || (_app$session$user = _app$session$user.preferences()) == null ? void 0 : _app$session$user['ramon-chat.sound']) === false) return null;
  const setting = app.forum.attribute('ramon-chat.notificationSound');
  if (!setting || setting === 'none') return null;
  return setting;
}

/**
 * URL publicada de um som. Os arquivos ficam em `assets/` da extensão e o
 * `flarum assets:publish` os copia para `assets/extensions/ramon-chat/`. Usa
 * `assetsBaseUrl` para funcionar com CDN ou subdiretório.
 */
function url(name) {
  var _app$forum$attribute;
  const base = (_app$forum$attribute = app.forum.attribute('assetsBaseUrl')) != null ? _app$forum$attribute : '/assets';
  return "".concat(base, "/extensions/ramon-chat/sounds/").concat(name, ".mp3");
}
export function playNotificationSound() {
  const name = chosen();
  if (!name) return;
  const now = Date.now();
  if (now - lastPlayed < THROTTLE_MS) return;
  lastPlayed = now;
  try {
    // Um elemento reutilizado: um Audio por mensagem vaza, e o navegador não coleta
    // um que está tocando.
    if (!element || loadedFor !== name) {
      element = new Audio(url(name));
      element.preload = 'auto';
      loadedFor = name;
    }
    element.currentTime = 0;

    // Autoplay é recusado até o usuário interagir com a página; é política do
    // navegador, não erro.
    void element.play().catch(() => {});
  } catch (_unused) {
    // URL malformada ou arquivo ausente nunca pode quebrar a entrega da mensagem.
  }
}

/** Toca uma vez ignorando o limite e a preferência; para a prévia do admin. */
export function previewSound(name) {
  if (!name || name === 'none') return;
  try {
    const audio = new Audio(url(name));
    void audio.play().catch(() => {});
  } catch (_unused2) {
    // Idem.
  }
}
flarum.reg.add('ramon-chat', 'forum/utils/sound', { playNotificationSound: playNotificationSound,previewSound: previewSound, });